<template lang="pug">
  section#results-section.container.results-section
    .header(v-if="showResults")
      .title
        h3.default.w-6 Showing
          strong.results.default-bold  {{total | withCommas}}
          |  results
          span.small  as of {{ goldenCopyPublishDate }}
      search-export(v-if="showResultComponent")
      .pagination(v-if="showResultComponent")
        .prev(@click="setPage(currentPage-1)")
          font-awesome-icon.arrow(icon="angle-left" size="lg", :class="{disabled: currentPage === 1}")
        .next(@click="setPage(currentPage+1)")
          font-awesome-icon.arrow(icon="angle-right" size="lg", :class="{disabled: currentPage === lastPage}")
    data-table(v-if="showResultComponent")
    .error-block(v-if="searchError")
      notice-block(
        type="warning",
        action="refresh",
        :info="`${searchError.message}`"
        :body="searchError.body"
        title="Warning"
      )
</template>
<script>
import { mapMutations, mapState, } from 'vuex'
import { SET_PAGE_NUMBER, } from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import goToSearch from '../../mixins/go-to-search'
import DataTable from '../data-table/DataTable'
import NoticeBlock from '../lei-components/NoticeBlock'
import SearchExport from '../search-components/SearchExport'

export default {
  components: {
    NoticeBlock,
    DataTable,
    SearchExport,
  },
  filters: {
    withCommas: (num) => {
      const p = String(num).indexOf('.')
      return String(num).replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => p < 0 || i < p ? `${m},` : m)
    },
  },
  mixins: [ routerSearch, goToSearch, ],
  computed: {
    showResultComponent () {
      return this.showResults && this.total !== 0
    },

    ...mapState('search', [
      'total',
      'lastPage',
      'currentPage',
      'showResults',
      'searchError',
      'goldenCopyPublishDate',
    ]),
  },
  methods: {
    setPage (val) {
      this.setPageNumber(val > this.lastPage ? this.lastPage : val)
      this.routerSearch('#results-section')
    },

    ...mapMutations(
      'search', {
        setPageNumber: SET_PAGE_NUMBER,
      }
    ),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .small {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
  }
  .notice-mobile
    display none

  .results-section
    flex-direction column
    .header
      width 100%
      display flex
      align-items center
      justify-content space-between
      .pagination
        display none

  @media (max-width: $laptop)
    .results-section
      order 4
      .header
        display: grid
        grid-template-columns: max-content 1fr max-content
        grid-gap: 10px
        .title h3
          font-size 1.1rem
          font-weight 700
        .optional
          justify-self: end
        .pagination
          width 60px
          justify-content space-between
          display flex
          .prev, .next
            width 24px
          .arrow
            font-size 3rem
            cursor pointer
            color $default-color-middle-1
            &:hover
              color $primary-color
            &.disabled
              color $default-color-light-1
              &:hover
                cursor not-allowed

  @media (max-width: 700px)
    .results-section
      .header
        grid-template-columns: 1fr max-content
        .optional
          margin-bottom: 10px
          justify-self: start
          order: 1
          grid-column: 1/3

</style>



// WEBPACK FOOTER //
// src/components/layout-components/Results.vue